export class FontStyleFormatHelper {
    static _textAnchorFormats = {
        "1": {
            glyph: "align-left",
            text: "Esquerda"
        },
        "2": {
            glyph: "align-center",
            text: "Centro"
        },
        "3": {
            glyph: "align-right",
            text: "Direita"
        }
    }

    static _targetTexts = {
        "code": "Código",
        "text": "Texto",
        "description": "Descrição",
        "schedule": "Horário",
        "hourlabel": "Horas (legenda)",
        "minutelabel": "Minutos (legenda)",
        "hour": "Horas",
        "minute": "Minutos",
        "previousstops": "Paragens Anteriores",
        "currentstop": "Paragem Alvo",
        "nextstops": "Próximas Paragens",
        "zones": "Zonas",
        "duration": "Duração",
        "smscode": "Código SMS",
        "stopcode": "Código da Paragem",
        "stopname": "Nome da Paragem",
        "linecode": "Código da Linha",
        "linename": "Nome da Linha",
        "qrcode": "QR Code",
        "previousstopstriptime": "Tempos de Paragens Anteriores",
        "currentstoptriptime": "Tempos da Paragem Alvo",
        "nextstopstriptime": "Tempos de Paragens Posteriores",
        "header": "Cabeçalho",
    }

    static getAllTextAnchorTexts() {
        const output = [];
        for(const prop in this._textAnchorFormats) {
            output.push(this._textAnchorFormats[prop].text);
        }

        return output;
    }

    static getTextAnchorText(textAnchor) {
        if(undefined === this._textAnchorFormats[textAnchor]) {
            return "";
        }

        return this._textAnchorFormats[textAnchor].text;
    }

    static getAllTextAnchorGlyphs() {
        const output = [];
        for(const prop in this._textAnchorFormats) {
            output.push(this._textAnchorFormats[prop].glyph);
        }

        return output;
    }

    static getTextAnchorGlyph(textAnchor) {
        if(undefined === this._textAnchorFormats[textAnchor]) {
            return "";
        }

        return this._textAnchorFormats[textAnchor].glyph;
    }

    static getTargetTextsArray(targetsArray) {
        const output = [];
        
        for(const idx in targetsArray) {
            output.push(this._targetTexts[targetsArray[idx].toLowerCase()]);
        }

        return output;
    }

    static getTargetText(target) {
        return this._targetTexts[target.toLowerCase()];
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/helpers/FontStyleFormatHelper.js